// src/utils/ciencia.js
import { supabase } from "../supabaseClient";

// Retorna um Map: nota_id -> Set(user_ids que confirmaram ciência)
export async function buscarConfirmacoesPorNotas(notaIds) {
  if (!notaIds?.length) return new Map();
  const { data, error } = await supabase
    .from("confirmacoes_ciencia")
    .select("nota_id, user_id")
    .in("nota_id", notaIds);
  if (error) {
    console.error("Erro ao buscar confirmações de ciência:", error);
    return new Map();
  }
  const map = new Map();
  data.forEach(({ nota_id, user_id }) => {
    if (!map.has(nota_id)) map.set(nota_id, new Set());
    map.get(nota_id).add(user_id);
  });
  return map;
}

// Retorna um Set com os nota_ids que o usuário atual já confirmou
export async function buscarMinhasConfirmacoes(userId, notaIds) {
  if (!userId || !notaIds?.length) return new Set();
  const { data, error } = await supabase
    .from("confirmacoes_ciencia")
    .select("nota_id")
    .eq("user_id", userId)
    .in("nota_id", notaIds);
  if (error) {
    console.error("Erro ao buscar minhas confirmações:", error);
    return new Set();
  }
  return new Set(data.map((d) => d.nota_id));
}

export async function marcarCiente(userId, notaId) {
  const { error } = await supabase
    .from("confirmacoes_ciencia")
    .insert({ user_id: userId, nota_id: notaId });
  if (error && error.code !== "23505") { // ignora conflito de unique (já confirmado)
    console.error("Erro ao marcar ciência:", error);
    return false;
  }
  return true;
}

export async function desmarcarCiente(userId, notaId) {
  const { error } = await supabase
    .from("confirmacoes_ciencia")
    .delete()
    .eq("user_id", userId)
    .eq("nota_id", notaId);
  if (error) {
    console.error("Erro ao desmarcar ciência:", error);
    return false;
  }
  return true;
}